export const CONFIG = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001',
} as const;

// Environment initialization logging
console.info('Environment Debug - RevenueSocial:', {
  API_BASE_URL: CONFIG.API_BASE_URL,
  NODE_ENV: process.env.NODE_ENV,
  RAW_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
});

// Validation function to ensure required environment variables are set
export const validateEnvironment = () => {
  // API_BASE_URL always has a default, so environment is always valid
  return true;
};